import DualPanelManageMembers from "./components/DualPanelManageMembers";
import { UsersAndCohortsList } from "./components/UsersAndCohorts";

export default Object.assign(DualPanelManageMembers, {
  CohortList: UsersAndCohortsList,
});
